;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import client from './client';

const api = {
    subscribe: data => {
        return client.post('/klaviyo/subscribe', data);
    },
    retrieveIceCreamCoupon: data => {
        return client.post('/klaviyo/retrieve-ice-cream-coupon', data);
    },
    campaignCreameryQrSubmitForm: data => {
        return client.post('/klaviyo/campaign-creamery-qr-submit-form', data);
    },
    campaignCreameryQrCheckExpiration: data => {
        return client.post(
            '/klaviyo/campaign-creamery-qr-check-expiration',
            data
        );
    },
    campaignCreameryQrClaimVoucher: data => {
        return client.post('/klaviyo/campaign-creamery-qr-claim-voucher', data);
    },
    retrievePromotion: data => {
        return client.post('/klaviyo/retrieve-promotion', data);
    },
    printPromotion: data => {
        return client.post('/klaviyo/print-promotion', data);
    },
    retrieveNewsletterSubscriptionStatus: data => {
        return client.post(
            '/klaviyo/retrieve-newsletter-subscription-status',
            data
        );
    },
    trackEvent: data => {
        return client.post('/klaviyo/track-event', data);
    },
};

export default api;
